import { useState } from 'react';
import DishMap from '@/components/DishMap';

const POS_CLASS = { tl: 'tl', tr: 'tr', bl: 'bl', br: 'br', top: 'top' };

function Title({ parts }) {
  return (
    <h2 className="D D-md rv">
      {parts.map((p, i) =>
        typeof p === 'string'
          ? <span key={i}>{p}</span>
          : <em key={i}>{p.em}</em>,
      )}
    </h2>
  );
}

function Arrow() {
  return (
    <span className="ddish-arrow" aria-hidden="true">
      <svg viewBox="0 0 60 12" preserveAspectRatio="none">
        <path d="M0 6 L52 6 M46 1 L52 6 L46 11" stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

function IngredientCard({ ingredient, index, isActive, isDimmed, dishId, onEnter, onClick }) {
  const { key, name, pos, origin, distance, note, img } = ingredient;
  return (
    <article
      className={`ddish-card pos-${POS_CLASS[pos] || 'top'} ${isActive ? 'on' : ''} ${isDimmed ? 'dim' : ''}`}
      onMouseEnter={onEnter}
      onClick={onClick}
      data-testid={`ddish-${dishId}-card-${key}`}
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="ddish-card-inner">
        {img && (
          <div className="ddish-card-img">
            <img src={img} alt={name} loading="lazy" />
          </div>
        )}
        <div className="ddish-card-body">
          <div className="ddish-card-num">0{index + 1}</div>
          <h3 className="ddish-card-name">{name}</h3>
          <p className="ddish-card-origin">
            <span className="ddish-card-origin-l">{origin}</span>
            {distance && <span className="ddish-card-km">{distance}</span>}
          </p>
          <p className="ddish-card-note">{note}</p>
        </div>
      </div>
      <Arrow />
    </article>
  );
}

export default function DeconstructedDish({ config, variant }) {
  const { id, eyebrow, titleParts, sub, plateImg, plateAlt, ingredients, map, mapNote } = config;
  const [active, setActive] = useState(null);

  return (
    <section className={`ddish ${variant === 'surf' ? 'ddish-surf' : ''}`} data-testid={`ddish-${id}`} id={id}>
      <div className="ddish-head">
        <p className="eyebrow rv">{eyebrow}</p>
        <Title parts={titleParts} />
        <p className="lead rv">{sub}</p>
      </div>

      <div className="ddish-radial rv" onMouseLeave={() => setActive(null)}>
        <div className="ddish-plate-center">
          <img src={plateImg} alt={plateAlt} loading="lazy" />
        </div>

        {ingredients.map((ing, i) => (
          <IngredientCard
            key={ing.key}
            ingredient={ing}
            index={i}
            isActive={active === ing.key}
            isDimmed={active !== null && active !== ing.key}
            dishId={id}
            onEnter={() => setActive(ing.key)}
            onClick={() => setActive(active === ing.key ? null : ing.key)}
          />
        ))}
      </div>

      {map && (
        <DishMap
          id={id}
          map={map}
          mapNote={mapNote}
          active={active}
          onActiveChange={setActive}
        />
      )}
    </section>
  );
}
